import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import CurrencyInput from '@/shared/components/currency-input/index.vue';
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { FormPartBData } from "@/trust-atcs-app/models/form-part-b-data";
import { ComplianceForm, PartBFormDeclaration } from "@/shared/modules/typescript-trustapi-client/models";
import { AuthorizedUser } from "@/trust-atcs-app/models/authorized-user";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {
    LoadingSpinner,
    CurrencyInput,
    DatePicker,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormPartBDeclaration extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop()
  private formPartBData!: FormPartBData;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;
  private declarationContent: PartBFormDeclaration = null as any;
  private recordsProvidedOn: Date | null = null;
  private examinationCost = null;

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  @Watch('examinationCost')
  private onExaminerCostChanged(): void {
    this.formPartBData.declarationDetails.examinationCost = this.examinationCost;
    this.$emit('validForm', this.validForm());
  }
  
  @Watch('recordsProvidedOn')
  private onRecordsProvidedOnChanged(): void {
    this.formPartBData.declarationDetails.recordsProvidedOn = this.recordsProvidedOn;
    this.$emit('validForm', this.validForm());
  }

  created(): void {
    this.loadDeclarationContent();
  }

  private async loadDeclarationContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetDeclarationPost({
        complianceFormId: this.complianceFormB.id,
        updatingKey: this.updatingKey,
        manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
      });

      this.declarationContent = resp.data.data as PartBFormDeclaration;
      this.formPartBData.declarationDetails = this.declarationContent;
      this.examinationCost = this.formPartBData.declarationDetails.examinationCost;
      this.recordsProvidedOn = this.formPartBData.declarationDetails.recordsProvidedOn ? new Date(this.formPartBData.declarationDetails.recordsProvidedOn) : null;

      setTimeout(()=>{
        this.$emit('validForm', this.validForm());
      }, 100);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content');
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    // return this.formPartBData.declarationDetails?.isPrincipal && this.formPartBData.declarationDetails?.hasTrustCoordinator &&
    //   Number.isInteger(this.examinationCost) && !!this.recordsProvidedOn;
    return this.userAccount?.user?.isPrincipal;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get completer(): string {
    try {
      return this.userAccount?.user?.firstName + ' ' + this.userAccount?.user?.lastName;
    } catch (err) {
      console.log(err);
      return '';
    }
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

